/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationLevel } from '../../models/education-level';

export interface GetEducationLevel$Params {
  id: string;
  'X-Region'?: any;
}

export function getEducationLevel(http: HttpClient, rootUrl: string, params: GetEducationLevel$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationLevel>> {
  const rb = new RequestBuilder(rootUrl, getEducationLevel.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Region', params['X-Region'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationLevel>;
    })
  );
}

getEducationLevel.PATH = '/educationlevel/{id}';
